import React from 'react';

const ConfirmationModal = ({ show, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div className="counter-modal fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-gray-700 opacity-50 fixed inset-0"></div>
      <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
        <div className='p-6'>
          <h2 className="text-lg font-bold mb-4">Confirm Status Change</h2>
          <p className='counter-mb'>Are you sure you want to change the status?</p>
          <p>Any <em>STATUS changes</em> made now will lock the Status dropdown</p>
          <p className='counter-mb'>from any further changes for the next <strong>150 minutes</strong></p>
        </div>
        <div className="bg-gray-50 sm:flex sm:flex-row-reverse p-6">
          <button onClick={onConfirm} className="text-white bg-emerald-400 hover:bg-emerald-300 focus:ring-2 focus:outline-none focus:ring-white font-medium rounded-lg text-md px-8 py-4 text-center mr-3 ml-8 md:mr-0 dark:bg-white-600 dark:hover:bg-blue-300 dark:focus:ring-z-blue">Continue</button>
          <button onClick={onCancel} className="text-white bg-slate-300 hover:bg-slate-200 focus:ring-2 focus:outline-none focus:ring-white font-medium rounded-lg text-md px-8 py-4 text-center mr-3 md:mr-0 dark:bg-white-600 dark:hover:bg-sky-300 dark:focus:ring-z-blue">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;